import { selectors as commonSelectors } from '~/domains/common';
import {
  selectors as agentScannersSelectors,
  actions as agentScannersActions
} from '~/domains/agentScanners';
import { isLoggedIn } from '~/utils/validations/profile';

const resolve = async ({ getState, dispatch }) => {
  const state = getState();
  const profile = commonSelectors.profile(state);
  const organizationId = profile?.organization?.id;

  isLoggedIn(profile);

  if (!agentScannersSelectors.isAgentScannersFlagEnabled(state)) {
    const error = new Error('Page not enabled');

    error.status = 404;

    throw error;
  }

  // Load scanners data if not already loaded
  const scanners = agentScannersSelectors.scanners(state);
  const isFetching = agentScannersSelectors.isFetchingScanners(state);

  if (organizationId && scanners.length === 0 && !isFetching) {
    await dispatch(agentScannersActions.loadAgentScanners(organizationId));
  }
};

export default resolve;
